<div class="hazard-block">
  <ion-card class="hazard-card">
    <ion-accordion-group>
      <ion-accordion value="initialHazard">
        <ion-item lines="none" slot="header"  tabindex="0">
          <ion-label>
            <div class="header-with-tabs">
              <span class="header-title">{{"Initial Hazard" | translate}}</span>
              <div class="mode-tabs">
                <div *ngFor="let mode of associatedMachineModes" class="mode-tab">
                  {{ mode.label | translate }}
                </div>
              </div>
            </div>
          </ion-label>
        </ion-item>

        <div class="accordion-content" slot="content">
          <ion-card class="inner-card-content scrollVertical ion-no-margin">
            <ion-textarea readonly [attr.tabindex]="isReadonly ? -1 : 0" [(ngModel)]="pickInitialHazardValue">
            </ion-textarea>
          </ion-card>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </ion-card>
  <div class="measure-cards-container" [class.measure-cards-readonly]="isReadonly">
    <div class="control-measure-card" *ngFor="let measure of dynamicMeasures; let i = index">
      <ion-card class="measure-card">
        <ion-card-content class="measure-card-content">
          <div class="flex-row space-between align-center first-row">
            <div class="left">
              <ion-label class="header-title">{{ 'Measures' | translate }}</ion-label>
            </div>
            <div class="right flex-row gap-small">
              <ion-label class="label-css">{{ 'Machine Mode' | translate }} </ion-label>
              <ng-select
                [items]="associatedMachineModes"
                bindLabel="label"
                [tabIndex]="isReadonly ? -1 : 0"
                [readonly]="isReadonly"
                [compareWith]="compareModeObjects"
                [(ngModel)]="measure.machineModes"
                [multiple]="true"
                [closeOnSelect]="true"
                name="machineMode"
                #machineMode="ngModel"
                (change)="changeMode($event, i)"
                placeholder="{{ 'Select Machine Mode' | translate }}"
                required
                class="machine-mode cust-name-select">
                <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
                  <input id="mode-item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}" [ngModel]="item$" />
                  {{item.label | translate}}
                </ng-template>
              </ng-select>
              <ion-button
                [attr.tabindex]="isReadonly ? -1 : ''"
                fill="outline"
                shape="round"
                (click)="addNewMeasureSection(i)">
                <ion-icon slot="start" name="add-circle-outline"></ion-icon>
                {{ 'New' | translate }}
              </ion-button>
              <ion-button
                [attr.tabindex]="isReadonly ? -1 : ''"
                fill="outline" class="pick-initial-btn" shape="round" position="bottom"
                (click)="handleOpenPickMeasure('Pick Measure', i, measure)">
                <ion-icon slot="start" name="add-circle-outline"></ion-icon>
                {{"From Library"|translate}}
              </ion-button>
              <ion-icon *ngIf="dynamicMeasures.length > 1 && !isReadonly" [attr.tabindex]="isReadonly ? -1 : 0" keyboardCloseIcon name="trash-outline" class="trash-icon delete-icon-transition" (click)="deleteMeasure(i)" [tooltip]="removeLabel" placement="bottom"></ion-icon>
            </div>
          </div>
          <div class="flex-row space-between second-row">
            <div class="left flex-column">
              <ion-label class="label-css measure-type-label">{{ 'Measure Type' | translate }}</ion-label>
              <ng-select class="measure-type-select-control" [items]="measureTypes" bindLabel="label" [bindValue]="null" [(ngModel)]="measure.selectedMeasureType"
                [tabIndex]="isReadonly ? -1 : 0"
                [readonly]="isReadonly"
                placeholder="{{ 'Select Type Of Measure' | translate }}" (change)="onChangeMeasureType($event, i)"
                [virtualScroll]='true' appendTo=".measure-cards-container" [dropdownPosition]="'bottom'">
                <ng-option *ngFor="let language of measureTypes" [value]="language?.value">{{language?.label}}</ng-option>
              </ng-select>
              <ion-text *ngIf="measure.showMeasureTypeRequiredError" color="danger">
                {{ 'This_field_is_required' | translate }}
              </ion-text>
              <ng-container *ngIf="isControlMeasureType(measure)">
                <ion-label class="label-css measure-name-label">{{ 'Measure Name' | translate }}</ion-label>
                <div class="measure-name-field">
                  <ng-select
                    class="measure-name-select"
                    [items]="measure._nameItems || []"
                    [addTag]="addMeasureNameTag"
                    [loading]="measure._nameLoading"
                    [searchable]="true"
                    [clearable]="true"
                    [(ngModel)]="measure.short_name"
                    [tabIndex]="isReadonly ? -1 : 0"
                    [readonly]="isReadonly"
                    (open)="onMeasureNameOpen(measure)"
                    (search)="onMeasureNameSearch(measure, $event)"
                    (scrollToEnd)="onMeasureNameScrollToEnd(measure)"
                    (change)="onMeasureNameChanged(measure, $event)"
                    (blur)="onMeasureNameBlur(measure)"
                    placeholder="{{ 'Enter Control Measure Name' | translate }}">
                  </ng-select>
                </div>
                <div class="measure-name-meta-row">
                  <ion-text *ngIf="measure.showWhitespaceOnlyShortNameError" class="measure-name-error">
                    {{ 'only_spaces_not_allowed' | translate }}
                  </ion-text>
                  <div class="char-count-container measure-name-count">
                    <ion-text>
                      {{ measure.short_name?.length || 0 }}/{{measureNameMaxLength}}
                    </ion-text>
                  </div>
                </div>
              </ng-container>
              <ion-button class="app-large-btn btn-height" shape="round" fill="outline" color="primary"
                [attr.tabindex]="isReadonly ? -1 : ''"
                [disabled]="isReadonly || !measure.measure_type_id || !measure.control_measure?.trim()"
                (click)="handleControlMeasureAddToLibrary(measure, description)">
                {{'Add to Library'|translate}}
              </ion-button>
            </div>
            <div class="right flex-column">
              <ion-label class="label-css description">{{ 'Description' | translate }}</ion-label>
              <ion-card class="inner-card-content scrollVertical">
                <app-ai-writing-field-shell
                  #description
                  class="measure-description-textarea"
                  [isReadonly]="isReadonly"
                  [maxlength]="measureDescMaxLength"
                  [rows]="4"
                  [(ngModel)]="measure.control_measure"
                  (ngModelChange)="onControlMeasureChanged(measure, description, i)"
                  placeholder="{{ 'Enter Description' | translate }}"
                  fieldContextType="control-measure-description" [historyKey]="'control-measure::' + i"
                >
                </app-ai-writing-field-shell>
              </ion-card>
              <div class="char-count-container">
                <ion-text *ngIf="measure?.control_measure?.length > defaultMeasureDescLength" color="danger">
                  {{'initial_hazard_description_max_length' | translate }}
                </ion-text>
                <ion-text [ngClass]="{ 'danger': measure?.control_measure?.length > defaultMeasureDescLength }">
                  {{measure.control_measure?.length || 0}}/{{defaultMeasureDescLength}}
                </ion-text>
              </div>
              <div *ngIf="measure.measure_type_id === 3" class="plr-container">
                <div class="flex-row align-center plr-inline-group">
                  <div class="input-item">
                    <ion-label>{{ 'Determined PLR' | translate }}</ion-label>
                    <ion-input class="plr-input" readonly tabindex="-1" [(ngModel)]="measure.measurePlrObj.plr ||  measure.measurePlrObj.sValue"></ion-input>
                  </div>
                  <div class="input-item">
                    <ion-label>{{ 'Recommended Category' | translate }}</ion-label>
                    <ion-input class="category-input" readonly tabindex="-1" [ngModel]="measure.measurePlrObj.category ? measure.measurePlrObj.category : ''"></ion-input>
                  </div>
                  <ion-button
                    [attr.tabindex]="isReadonly ? -1 : ''"
                    shape="round"
                    fill="outline"
                    color="primary"
                    class="plr-btn"
                    (click)="handleDeterminePlr(measure, i)">
                    {{ 'Determined PLR' | translate }}
                  </ion-button>
                </div>

                <div class="flex-row align-center plr-checkbox-row">
                  <ion-checkbox
                    [attr.tabindex]="isReadonly ? -1 : ''"
                    [(ngModel)]="measure.measurePlrObj.isIncludeRecommandedCategory"
                    (ionChange)="toggleIncludeCategory(measure, i)">
                  </ion-checkbox>
                  <ion-label class="checkbox-label">{{ 'Include Recommended Category' | translate }}</ion-label>
                </div>
              </div>
              <div *ngIf="measure?.measurePlrObj?.plrDescription"> 
        <ion-label class="label-css description">{{ 'plr_description' | translate }}</ion-label>
              <ion-card class="plr-description ">
                <ion-textarea
                *ngIf="measure.measurePlrObj.isPlrFromGraph"
                   tabindex="-1"
                   [readonly]="true"   
                  [(ngModel)]="measure.measurePlrObj.plrDescription"
                >
                </ion-textarea>
                <div *ngIf="!measure.measurePlrObj.isPlrFromGraph" [readonly]="true"   class="description-container" [innerHTML]="measure.measurePlrObj.plrDescription"></div>
              </ion-card>
              </div>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>
  </div>
</div>